// extracted by mini-css-extract-plugin
export var button = "Button-module--button--bce7b";
export var inverse = "Button-module--inverse--a0212";
export var lg = "Button-module--lg--fc752";
export var md = "Button-module--md--30d2f";
export var outline = "Button-module--outline--25b87";
export var primary = "Button-module--primary--ed7bd";
export var sm = "Button-module--sm--896c5";